'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContentAdvisoryTypePicker = require('./components/ContentAdvisoryTypePicker');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContentAdvisoryTypePicker).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/content-advisory-type-picker/index.js
// module id = 866
// module chunks = 4